
// hamburger menu
document.addEventListener('DOMContentLoaded', () => {
	const toggleBtn = document.querySelector('.menu-toggle');
	const navMenu = document.querySelector('.nav');

	toggleBtn.addEventListener('click', () => {
		toggleBtn.classList.toggle('active');
		navMenu.classList.toggle('active');
	});
});

